import styled from 'styled-components'
import { Box as GBox } from '@usap/uicomponents'

export const Box = styled(GBox)`
  display: flex;
`

export const SeoPartAndAccessoriesBox = styled(Box)`
  background: #fff;
`

export const SeoPartAndAccessoriesContainer = styled(Box)`
  margin: 0px auto;
  padding: 12px 6px;
  width: 100%;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    padding: 16px 8px;
    width: 1248px;
  }
`

export const PartAndAccessoriesHeadingBox = styled(Box)`
  margin: ${props => props.theme.global.edgeSize.xsmall};

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin: ${props => props.theme.global.edgeSize.small};
  }
`
